import { apiSlice } from "../api-slice";
import { GetProposalParams } from "../gms/proposal/proposal-api-request";
import { AmendmentRequestHistoryData, GetRequestAmendmentsHistoryDataResponse, GetRequestAmendmentsHistoryResponse, GetRequestAmendmentsLogsResponse, RequestAmendmentsResponse } from "./request-amendment-api-state";

export const requestAmendmentAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRequestAmendmentsLogs: builder.query<AmendmentRequestHistoryData[], {proposalId: number}>({
            query: ({proposalId}) => `/api/financial-insurance/${proposalId}/amendment-history`,
            transformResponse: (response: GetRequestAmendmentsLogsResponse) => response.data,
            transformErrorResponse: (response: any) => response,
            providesTags: (result, error, { proposalId }) => [
                { type: "Amendments", id: proposalId },
                { type: "Amendments", id: "LIST" },
                { type: "Proposal", id: proposalId },
                { type: "Proposal", id: "LIST" },
            ],
        }),
        getRequestAmendments: builder.query<GetRequestAmendmentsHistoryDataResponse, undefined | GetProposalParams>({
            query: (params) => ({
                url: `/api/actuarial/amendment/queue`,
                params: params ?? {},
            }),
            transformResponse: (response: GetRequestAmendmentsHistoryResponse) => response.data,
            transformErrorResponse: (response: any) => response,
            providesTags: [{ type: 'Amendments', id: 'LIST' }],
        }),
        // createRequestAmendment: builder.mutation<RequestAmendmentsResponse, { proposalId: number, request_notes: string; proposed_data: any}>({
        //     query: ({proposalId, request_notes}) => ({
        //         url: `/api/financial-insurance/${proposalId}/request-amendment`,
        //         method: 'PUT',
        //         body: { request_notes },
        //     }),
        //     transformErrorResponse: (response: any) => response.data,
        //     invalidatesTags: (_result, _error, { proposalId }) => [
        //         { type: 'Amendments', id: proposalId },
        //         { type: 'Amendments', id: 'LIST' },
        //         { type: 'Proposal', id: proposalId },
        //         { type: 'Proposal', id: 'LIST' },
        //     ],
        // }),
        createRequestAmendment: builder.mutation<RequestAmendmentsResponse, { proposalId: number; request_notes: string; proposed_data: Record<string, any> | null; file?: File | null }>({
            query: ({ proposalId, request_notes, proposed_data, file }) => {
                const formData = new FormData();

                formData.append('request_notes', request_notes);
                formData.append('proposed_data', JSON.stringify(proposed_data));

                if (file instanceof File) {
                    formData.append('file', file);
                }

                return {
                    url: `/api/financial-insurance/${proposalId}/request-amendment`,
                    method: 'PUT',
                    body: formData,
                };
            },
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (_result, _error, { proposalId }) => [
                { type: 'Amendments', id: proposalId },
                { type: 'Amendments', id: 'LIST' },
                { type: 'Proposal', id: proposalId },
                { type: 'Proposal', id: 'LIST' },
            ],
        }),
        declineRequestAmendment: builder.mutation<RequestAmendmentsResponse, { proposalId: number, response_notes: string;}>({
            query: ({proposalId, response_notes}) => ({
                url: `/api/actuarial/amendment/${proposalId}/decline`,
                method: 'PUT',
                body: { response_notes },
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (_result, _error, { proposalId }) => [
                { type: 'Amendments', id: proposalId },
                { type: 'Amendments', id: 'LIST' },
                { type: 'Proposal', id: proposalId },
                { type: 'Proposal', id: 'LIST' },
            ],
        }),
        acceptRequestAmendment: builder.mutation<RequestAmendmentsResponse, { proposalId: number}>({
            query: ({proposalId}) => ({
                url: `/api/actuarial/amendment/${proposalId}/approve`,
                method: 'PUT',
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (_result, _error, { proposalId }) => [
                { type: 'Amendments', id: proposalId },
                { type: 'Amendments', id: 'LIST' },
                { type: 'Proposal', id: proposalId },
                { type: 'Proposal', id: 'LIST' },
            ],
        }),
        downloadAttachmentFile: builder.mutation<string, { amendId: number }>({
            query: ({ amendId }) => ({
                url: `api/financial-insurance/amendment-attachment/${amendId}/download`,
                method: "GET",
                responseHandler: async (response) => {
                    if (!response.ok) {
                        const contentType = response.headers.get('content-type') || '';

                        if (contentType.includes('application/json')) {
                            const errorData = await response.json();

                            throw new Error(
                                errorData?.message ||
                                errorData?.error ||
                                `Failed to download attachment. (${response.status})`,
                            );
                        }

                        const errorText = await response.text();

                        throw new Error(
                            errorText ||
                            `Failed to download attachment. (${response.status})`,
                        );
                    }

                    return response.blob();
                },
            }),
            transformResponse: (response: Blob) => {
                return URL.createObjectURL(response);
            },
        }),
    })
})

export const {
    useGetRequestAmendmentsLogsQuery,
    useGetRequestAmendmentsQuery,
    useCreateRequestAmendmentMutation,
    useDeclineRequestAmendmentMutation,
    useAcceptRequestAmendmentMutation,
    useDownloadAttachmentFileMutation,
} = requestAmendmentAPI